import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByServices'
})
export class FilterByServicesPipe implements PipeTransform {

  transform(items: any, services: any): any {

    return items.filter( it => {
          if (it.services.collect && services.collect) {
            return it;
          } else if (it.services.treatment && services.treatment) {
            return it;
          }
        });

  }

}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/filters/filter-by-services.pipe.ts